import { useCallback, useMemo } from 'react';
import { LocalStore, useLocalStore } from 'shared/helpers/Store';
import { tryParseJSON } from 'shared/utils/DataUtils';

const SELECTED_DRIVERS_KEY = 'load_suggestions_selected_drivers';

export interface SelectedDriver {
  guid: string;
  name: string;
}

export function storeSelectedDrivers(value: SelectedDriver[]) {
  LocalStore.set(SELECTED_DRIVERS_KEY, JSON.stringify(value));
}

export function useSelectedDrivers() {
  const storageValue = useLocalStore(SELECTED_DRIVERS_KEY);

  const drivers = useMemo(() => {
    if (storageValue) {
      return tryParseJSON<SelectedDriver[]>(storageValue) || [];
    }
    return [];
  }, [storageValue]);

  const setDrivers = useCallback((value: SelectedDriver[]) => {
    storeSelectedDrivers(value);
  }, []);

  return [drivers, setDrivers] as const;
}
